import React, { useState, useEffect } from "react";
import CustomNavbar from "../../components/CustomNavbar";
import { useSelector, useDispatch } from "react-redux";
import SidebarDashboard from "../../components/SidebarDashboard";
import { useHistory } from "react-router-dom";
import {
  Alert,
  Button,
  Card,
  Row,
  Col,
  Form,
  Spinner,
  Dropdown,
  Container,
  Table,
} from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";

import "../../css/fileInput.css"
//Redux
import {
  getPlanSeguimiento,
  savePlanSeguimiento,
  editPlanSeguimiento
} from "../../redux/planCarrera/PlanSeguimiento/actions"
import { getPlanAcciones } from "../../redux/evaluacion_desempenio/plan_accion/actions";
import { getStatus } from "../../redux/planCarrera/Estados/actions";

import moment from "moment";
import { Formik } from "formik";
import * as Yup from "yup";


const PlanSeguimiento = (props) => {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const [show, setShow] = useState(true);
  const [download, setDownload] = useState(null);
  const [validated, setValidated] = useState(false);
  const onShowSidebar = () => setShow(show ? false : true);
  const dispatch = useDispatch();
  const history = useHistory();

  //esquema de validación
  const schema = Yup.object().shape({
    comentario_debilidad: Yup.string().required("**Campo requerido"),
    tipo_plan: Yup.string().required("**Campo requerido"),
    plan_documento: Yup.mixed(),
    fecha_inicio: Yup.date()
      .required("**Campo requerido")
      .test("fecha_inicio", "La fecha de inicio debe ser anterior a la fecha de fin", function (value) {
        return value <= this.parent.fecha_fin;
      }),
    fecha_fin: Yup.date()
      .required("**Campo requerido")
      .min(Yup.ref("fecha_inicio"), "La fecha de fin debe ser posterior a la fecha de inicio")
  });

  //Plan seguimiento
  const {
    loading,
    saveLoading,
    planSeguimiento,
    planSeguimientoError,
    formError
  } = useSelector((store) => store.planCarreraPlanSeguimiento);

  const { loaderPlanAccion, planAccion } = useSelector(
    (store) => store.planAccion
  );
  //Roles
  const userRoles = useSelector((store) => store.auth.userRoles);

  const planAccionesOptions = planAccion
    ? planAccion.data.map((item) => ({
      id: item.id,
      label: item.descripcion,
      item: item,
    }))
    : [];

  const {
    loading: loadingStatuses,
    statuses
  } = useSelector((store) => store.planCarreraStatus);
  const estadoPendiente = statuses.filter((item) => item.nombre.toUpperCase() === "PENDIENTE")


  const _getPlanSeguimiento = () => {
    dispatch(getPlanSeguimiento({
      periodicidad_id: props.match.params.idPeriodicidad,
      competencia_evaluacion_id: props.match.params.idCompetencia,
      factor_evaluacion_id: props.match.params.idFactor
    }))
  }

  useEffect(() => {
    _getPlanSeguimiento()
    dispatch(getPlanAcciones())
    dispatch(getStatus())
  }, [])

  const valoresDesempenio = [
    {
      nombre: "Deficiente",
      color: "#FF3737"
    },
    {
      nombre: "Regular",
      color: "#FFC107"
    },
    {
      nombre: "Bueno",
      color: "#F7DC6F"
    },
    {
      nombre: "Muy Bueno",
      color: "#8BC34A"
    }
    ,
    {
      nombre: "Excelente",
      color: "#2ECC71"
    }
  ]

  const onSubmit = async (req) => {
    console.log("req", req)
    let filters = {
      periodicidad_id: props.match.params.idPeriodicidad,
      competencia_evaluacion_id: props.match.params.idCompetencia,
      factor_evaluacion_id: props.match.params.idFactor
    }

    const formData = new FormData();


    formData.append('comentario_debilidad', req.comentario_debilidad);
    formData.append('tipo_plan', req.tipo_plan);
    formData.append('fecha_inicio', moment(req.fecha_inicio).format('DD-MM-YYYY'));
    formData.append('fecha_fin', moment(req.fecha_fin).format('DD-MM-YYYY'));


    if (req.plan_documento) {
      formData.append('plan_documento', req.plan_documento);
    }

    formData.append('evaluacion_competencia', props.match.params.idCompetencia)
    formData.append('evaluacion_factor', props.match.params.idFactor)
    formData.append('colaborador', props.match.params.idEvaluado)
    formData.append('estado', estadoPendiente?.[0]?.id)

    for (let pair of formData.entries()) {
      console.log(pair[0] + ': ' + pair[1]);
    }

    if (!planSeguimiento.planes) {
      dispatch(savePlanSeguimiento(formData, filters))
    }
    else {
      const formPlanData = new FormData();

      formPlanData.append('tipo_plan', req.tipo_plan)
      formPlanData.append('fecha_inicio', moment(req.fecha_inicio).format('YYYY-MM-DD'))
      formPlanData.append('fecha_fin', moment(req.fecha_fin).format('YYYY-MM-DD'))

      if (req.plan_documento)
        formPlanData.append('plan_documento', req.plan_documento)

      let planAccionData = {
        comentario_debilidad: req.comentario_debilidad
      }
      dispatch(editPlanSeguimiento(planAccionData, formPlanData, planSeguimiento.planes[0].list_plan_accion[0].id, planSeguimiento.planes[0].id, filters))
    }


  }

  function DownloadDocument({ documentPath }) {

    const baseURL = process.env.REACT_APP_URL;
    const documentURL = `${baseURL}media/${documentPath}`;
    const fileName = documentPath.split("/").pop();

    return (

      <>
        <a href={documentURL} download>
          <Button className="bg-success mb-2">
            <i className="material-icons mr-1">download</i>
            Descargar Archivo
          </Button>
        </a>
        <span className="file-name">{fileName}</span>
      </>

    );
  }

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid className="p-4">
          {/* Título con botón para volver */}
          <Row className="align-items-center mb-3">
            <Col xs="auto">
              <Button
                onClick={() => history.goBack()}
                variant="link"
                className="font-weight-bold text-dark"
              >
                <i className="material-icons">arrow_back</i>
              </Button>
            </Col>
            <Col>
              <h6 className="font-weight-bold text-uppercase">
                Plan de Seguimiento
              </h6>
            </Col>
            {console.log(userRoles, userRoles.includes("Responsable_Carrera"))}
            {(userRoles.includes("Responsable_Carrera") || userRoles.includes("administrador")) && (
              <Col xs="auto">
                <Button
                  onClick={() => history.push("/plan-carrera/planes")}
                >
                  Ir a Mantenimiento de Planes <i className="material-icons">arrow_forward</i>
                </Button>
              </Col>
            )}

          </Row>
          <hr />
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            <Formik
              validationSchema={schema}
              onSubmit={(values) => {
                const formattedValues = {
                  ...values,
                  fecha_inicio: moment(values.fecha_inicio).format("YYYY-MM-DD"),
                  fecha_fin: moment(values.fecha_fin).format("YYYY-MM-DD"),
                };

                console.log("Formulario enviado con valores:", formattedValues);
                onSubmit(formattedValues);
              }}
              initialValues={{
                comentario_debilidad: planSeguimiento.comentario_debilidad ? planSeguimiento.comentario_debilidad : "",
                tipo_plan: planSeguimiento.planes ? planSeguimiento.planes[0].list_tipo_plan[0].id : "",
                plan_documento: "",
                fecha_inicio: planSeguimiento.planes ? moment(planSeguimiento.planes[0].fecha_inicio).format("YYYY-MM-DD") : moment(),
                fecha_fin: planSeguimiento.planes ? moment(planSeguimiento.planes[0].fecha_fin).format("YYYY-MM-DD") : moment().add(1, "day")
              }}
            >

              {({
                handleSubmit,
                handleChange,
                handleBlur,
                setFieldValue,
                values,
                touched,
                errors,
              }) => (
                <Form onSubmit={handleSubmit} noValidate validated={validated} >
                  <div className="mt-4">
                    {!!formError && (
                      <Alert variant="danger" className="mb-3">
                        {formError}
                      </Alert>
                    )}

                    <Row className="pb-2">

                      <Col lg={8}>
                        <Row>
                          {planSeguimiento?.planes?.[0]?.plan_documento && (
                            <Col lg={12}>
                              <DownloadDocument documentPath={planSeguimiento.planes[0].plan_documento} />
                            </Col>
                          )}
                          <Col lg={12}>
                            <Form.Label className="custom-file-upload">
                              <i className="material-icons m-1">upload_file</i>
                              <input
                                type="file"
                                name="plan_documento"
                                id="plan_documento"
                                onChange={(e) => setFieldValue("plan_documento", e.target.files[0])}
                              />
                              {planSeguimiento?.planes?.[0]?.plan_documento ? "Cambiar archivo" : "Subir archivo"}
                            </Form.Label>
                            <span className="file-name">{values.plan_documento ? `${values.plan_documento.name}` : 'No se ha seleccionado un archivo'}</span>
                          </Col>

                        </Row>


                      </Col>
                      <Col lg={4} className="text-right">
                        <Button
                          disabled={saveLoading}
                          type="submit"
                        >
                          {saveLoading && (
                            <Spinner
                              className="mr-2"
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />

                          )}
                          <i className="material-icons m-1">save</i>
                          <span className="p-2">Guardar</span>

                        </Button>
                      </Col>
                    </Row>
                    <hr />
                    <Card>
                      <Card.Header>
                        <Card.Title className="text-muted text-uppercase text-center">
                          <h5>
                            F-897 Plan de Seguimiento
                          </h5>
                        </Card.Title>
                      </Card.Header>
                      <Card.Body>


                        {/* Descripción */}
                        <Row className="mb-4">
                          <Col>
                            <p className="text-muted">
                              Instrumento para el seguimiento de la mejora continua del
                              desempeño laboral de los colaboradores.
                            </p>
                          </Col>
                        </Row>

                        {/* Tabla de Datos del Evaluador */}
                        <Row className="mb-5">
                          <Col lg={12} className="my-3">
                            <h6>Datos del Evaluador</h6>
                          </Col>
                          <Col lg={12}>
                            <Table
                              striped
                              bordered
                              hover
                              responsive
                              className="text-center"
                            >
                              <thead className="thead-dark">
                                <tr>
                                  <th>Nombre</th>
                                  <th>Código</th>
                                  <th>Función</th>
                                  <th>Área</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>{planSeguimiento?.evaluador_nombre}</td>
                                  <td>{planSeguimiento?.evaludor_codigo}</td>
                                  <td>{planSeguimiento?.evaludor_funcion}</td>
                                  <td>{planSeguimiento?.evaludor_area}</td>
                                </tr>
                              </tbody>
                            </Table>
                          </Col>
                        </Row>

                        {/* Tabla de Datos del Evaluado */}
                        <Row className="mb-5">
                          <Col lg={12} className="my-3">
                            <h6>Datos del Evaluado</h6>
                          </Col>
                          <Col lg={12}>
                            <Table
                              striped
                              bordered
                              hover
                              responsive
                              className="text-center"
                            >
                              <thead className="thead-dark">
                                <tr>
                                  <th>Nombre</th>
                                  <th>Código</th>
                                  <th>Función</th>
                                  <th>Fecha del Seguimiento</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>{planSeguimiento?.evaluado_nombre}</td>
                                  <td>{planSeguimiento?.evaluado_codigo}</td>
                                  <td>{planSeguimiento?.evaludo_funcion}</td>
                                  <td>{planSeguimiento?.fecha_seguimiento}</td>
                                </tr>
                              </tbody>
                            </Table>
                          </Col>
                        </Row>

                        {/* Tabla de Datos del Resultado de Evaluación del Desempeño */}
                        <Row className="mb-5">
                          <Col lg={12} className="my-3">
                            <h6>Resultado de Evaluación del Desempeño Individual</h6>
                          </Col>
                          <Col lg={12}>
                            <Table
                              striped
                              bordered
                              hover
                              responsive
                              className="text-center"
                            >
                              <thead className="thead-dark">
                                <tr>
                                  {
                                    valoresDesempenio.map((item) => (
                                      <th>{item.nombre}</th>
                                    ))
                                  }
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  {
                                    valoresDesempenio.map((item) => (
                                      <td>
                                        {item.nombre === planSeguimiento?.desempenio ? (
                                          <div className="rounded border border-2 p-2" style={{ fontWeight: "bold", backgroundColor: item.color }}>
                                            x
                                          </div>
                                        ) :
                                          ""}
                                      </td>
                                    ))
                                  }

                                </tr>
                              </tbody>
                            </Table>
                          </Col>
                        </Row>


                        <Row className="mb-5">
                          <Col lg={12}>

                            <Form.Group>
                              <Form.Label><span style={{ fontWeight: "800" }}>Debilidades detectadas: </span>se debe registrar todos aquellos
                                aspectos que se originan en la evaluación del desempeño como debilidades o deficiencias en el colaborador,
                                con la finalidad de iniciar un proceso de mejora personal que le permita mejorar su rendimiento laboral
                                para elevar los resultados obtenidos y poder alcanzar lo previsto por la organización.
                              </Form.Label>
                              <Form.Control
                                as="textarea"
                                rows="3"
                                placeholder="Escriba sus comentarios aquí..."
                                id="comentario_debilidad"
                                name="comentario_debilidad"
                                isInvalid={touched.comentario_debilidad && errors.comentario_debilidad}
                                isValid={touched.comentario_debilidad && !errors.comentario_debilidad}
                                onBlur={handleBlur("comentario_debilidad")}
                                onChange={handleChange}
                                value={values.comentario_debilidad}
                              />
                            </Form.Group>

                            <Form.Group>
                              <Form.Label style={{ fontWeight: "800" }}> PLAN DE ACCIÓN</Form.Label>
                              <Table
                                striped
                                bordered
                                hover
                                responsive
                                className="text-center"
                              >
                                <thead className="thead-dark">
                                  <tr>
                                    <th rowSpan={2}>Acciones de Mejora (Propuesta)</th>
                                    <th colSpan={2}>Plazo de Ejecución</th>
                                  </tr>
                                  <tr>

                                    <th>Inicio</th>
                                    <th>Fin</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td style={{ position: "relative" }}>
                                      <Typeahead
                                        id="tipo_plan"
                                        name="tipo_plan"
                                        isInvalid={touched.tipo_plan && errors.tipo_plan}
                                        isValid={touched.tipo_plan && !errors.tipo_plan}
                                        onBlur={handleBlur("tipo_plan")}
                                        placeholder="Seleccione un tipo de plan"
                                        options={planAccionesOptions}
                                        value={values.tipo_plan}
                                        onChange={(selected) => {
                                          setFieldValue(
                                            "tipo_plan",
                                            selected.length > 0 ? selected[0].id : ""
                                          );

                                        }}
                                        defaultInputValue={planSeguimiento.planes ? planSeguimiento.planes[0].list_tipo_plan[0].descripcion
                                          : ""}
                                        dropup={false}

                                        positionFixed

                                      >

                                      </Typeahead>
                                      <div className="text-danger">
                                        {errors.tipo_plan}
                                      </div>
                                    </td>
                                    <td>
                                      <input
                                        type="date"
                                        id="fecha_inicio"
                                        name="fecha_inicio"
                                        isInvalid={touched.fecha_inicio && errors.fecha_inicio}
                                        isValid={touched.fecha_inicio && !errors.fecha_inicio}
                                        onBlur={handleBlur("fecha_inicio")}
                                        onChange={handleChange}
                                        value={moment(values.fecha_inicio).format("YYYY-MM-DD")}
                                        style={{
                                          padding: "8px 10px",
                                          borderRadius: "20px",
                                          borderColor: errors.fecha_inicio ? "#ff0000" : "#92929380"
                                        }}
                                      />
                                      <div className="text-danger">
                                        {errors.fecha_inicio}
                                      </div>
                                    </td>
                                    <td>
                                      <input
                                        type="date"
                                        id="fecha_fin"
                                        name="fecha_fin"
                                        isInvalid={touched.fecha_fin && errors.fecha_fin}
                                        isValid={touched.fecha_fin && !errors.fecha_fin}
                                        onBlur={handleBlur("fecha_fin")}
                                        onChange={handleChange}
                                        value={moment(values.fecha_fin).format("YYYY-MM-DD")}
                                        style={{
                                          padding: "8px 10px",
                                          borderRadius: "20px",
                                          borderColor: errors.fecha_inicio ? "#ff0000" : "#92929380"
                                        }}
                                      />
                                      <div className="text-danger">
                                        {errors.fecha_fin}
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </Table>
                            </Form.Group>

                          </Col>

                        </Row>

                        {/* Tabla de Comentarios */}
                        <Row className="mb-5">
                          <Col lg={12} className="my-3">
                            <h6>Comentarios</h6>
                          </Col>
                          <Col lg={12}>
                            <Table
                              striped
                              bordered
                              hover
                              responsive
                              className="text-center"
                            >
                              <thead className="thead-dark">
                                <tr>
                                  <th>Evaluador</th>
                                  <th>Evaluado</th>

                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>{planSeguimiento?.comentario_evaluador}</td>
                                  <td>{planSeguimiento?.comentario_evaluado}</td>

                                </tr>
                              </tbody>
                            </Table>
                          </Col>
                        </Row>
                        <Col md="12">
                          <Row className="mt-5 mb-3 d-flex">
                            <Col md="4" xs="auto" className="mx-auto my-5">
                              <Row className="mt-3 d-flex flex-wrap justify-content-sm-between">
                                <Col
                                  className="mb-1 d-flex flex-wrap justify-content-center align-items-center"
                                  md="12"
                                >
                                  <p className="text-uppercase">
                                    <b>
                                      {planSeguimiento?.evaluador_nombre}
                                    </b>
                                  </p>
                                </Col>
                                <Col md="12">
                                  <div className="px-2">
                                    <hr
                                      style={{
                                        borderColor: "black",
                                      }}
                                    />
                                  </div>
                                </Col>
                                <Col md="12">
                                  <Row className="d-flex flex-wrap justify-content-center align-items-center px-2">
                                    <Col
                                      className="d-flex flex-wrap justify-content-center align-items-center"
                                      md="12"
                                    >
                                      <p className="text-uppercase">
                                        <b>FIRMA DEL EVALUADOR</b>
                                      </p>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </Col>
                            <Col md="4" xs="auto" className="mx-auto my-5">
                              <Row className="mt-3 d-flex flex-wrap justify-content-sm-between">
                                <Col
                                  className="mb-1 d-flex flex-wrap justify-content-center align-items-center"
                                  md="12"
                                >
                                  <p className="text-uppercase">
                                    <b>
                                      {planSeguimiento?.evaluado_nombre}
                                    </b>
                                  </p>
                                </Col>
                                <Col md="12">
                                  <div className="px-2">
                                    <hr
                                      style={{
                                        borderColor: "black",
                                      }}
                                    />
                                  </div>
                                </Col>
                                <Col md="12">
                                  <Row className="d-flex flex-wrap justify-content-center align-items-center px-2">
                                    <Col
                                      className="d-flex flex-wrap justify-content-center align-items-center"
                                      md="12"
                                    >
                                      <p className="text-uppercase">
                                        <b>FIRMA DEL EVALUADO</b>
                                      </p>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </Col>
                      </Card.Body>
                    </Card>
                  </div>
                </Form>
              )}

            </Formik>

          )
          }
        </Container>
      </div>


    </>
  );
};

export default PlanSeguimiento;
